import { render, staticRenderFns } from "./BankDetailsTab.vue?vue&type=template&id=8d0f28ba&scoped=true&"
import script from "./BankDetailsTab.vue?vue&type=script&lang=js&"
export * from "./BankDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0f28ba",
  null
  
)

export default component.exports